export default "__VITE_ASSET__BiZ9iIDo__"